import { Box, Tab, Tabs } from "@mui/material";
import { User } from "../../utils";
import { useState } from "react";
import { Company } from "../../types";
import BrandVoices from "./BrandVoices";
import BrandImages from "./BrandImages";
import ContentCampaigns from "./ContentCampaigns";
import ContentList from "./ContentList";
import ContentMetricsBar from "./ContentMetricsBar";
import ContentStrategiesList from "./ContentStrategiesList";
import IdealCustomerProfiles from "./IdealCustomerProfiles";
import InfoAccordion from "../../components/InfoAccordion";

export default ({
  currentUser,
  getToken,
  openDialog,
  eventListener,
  companyId,
  company,
  currentPlan,
}: {
  getToken: Function;
  openDialog: Function;
  eventListener: Function;
  currentUser: any | User;
  companyId: string;
  company: Company;
  currentPlan: string;
}) => {
  const [currentTab, setCurrentTab] = useState("content");
  return (
    <Box>
      <Box>
        <ContentMetricsBar
          companyId={companyId}
          getToken={getToken as () => Promise<string>}
        />
        <InfoAccordion title="Content Creation Workflow" sx={{ mt: 2 }}>
          <Box component="ol" sx={{ mt: 1, pl: 2 }}>
            <li><em>(Optional)</em> Create an Ideal Customer Profile to better target your content</li>
            <li><em>(Optional)</em> Define a Content Strategy with pillars for each funnel stage (TOFU, MOFU, BOFU)</li>
            <li><em>(Optional)</em> Establish your Brand Voice to maintain consistent messaging</li>
            <li><em>(Optional)</em> Upload Brand Images like logos and product shots for AI-generated content</li>
            <li>Set up Content Campaigns to organize your content production</li>
            <li>Create and manage individual Content pieces</li>
          </Box>
          Start with any step that fits your current needs.
        </InfoAccordion>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={currentTab}
            onChange={(e: any, v: string) => {
              setCurrentTab(v);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab label="1: Ideal Customer Profile" value="profiles" />
            <Tab label="2: Content Strategy" value="strategy" />
            <Tab label="3: Brand Voice" value="brand" />
            <Tab label="4: Brand Images" value="images" />
            <Tab label="5: Campaigns" value="campaigns" />
            <Tab label="6: Content" value="content" />
          </Tabs>
        </Box>
        {currentTab === "content" && (
          <ContentList
            currentUser={currentUser}
            company={company}
            companyId={companyId}
            getToken={getToken as () => Promise<string>}
            eventListener={eventListener as (event: any) => void}
            openDialog={openDialog as (title: string, content: string, buttonText: string, onClick: () => void) => void}
            currentPlan={currentPlan}
          />
        )}
        {currentTab === "campaigns" && (
          <ContentCampaigns
            currentUser={currentUser}
            company={company}
            companyId={companyId}
            getToken={getToken}
            eventListener={eventListener}
            openDialog={openDialog}
            currentPlan={currentPlan}
          />
        )}
        {currentTab === "profiles" && (
          <IdealCustomerProfiles
            currentUser={currentUser}
            company={company}
            companyId={companyId}
            getToken={getToken}
            eventListener={eventListener}
            openDialog={openDialog}
            currentPlan={currentPlan}
          />
        )}
        {currentTab === "brand" && (
          <BrandVoices
            currentUser={currentUser}
            company={company}
            companyId={companyId}
            getToken={getToken}
            eventListener={eventListener}
            openDialog={openDialog}
            currentPlan={currentPlan}
          />
        )}
        {currentTab === "images" && (
          <BrandImages
            currentUser={currentUser}
            company={company}
            companyId={companyId}
            getToken={getToken}
            eventListener={eventListener}
            openDialog={openDialog}
            currentPlan={currentPlan}
          />
        )}
        {currentTab === "strategy" && (
          <ContentStrategiesList
            currentUser={currentUser}
            company={company}
            companyId={companyId}
            getToken={getToken}
            eventListener={eventListener}
            openDialog={openDialog}
            currentPlan={currentPlan}
          />
        )}
      </Box>
    </Box>
  );
};
